import { render, staticRenderFns } from "./growthSourcingBoard.vue?vue&type=template&id=2c641d5a"
import script from "./growthSourcingBoard.vue?vue&type=script&lang=js"
export * from "./growthSourcingBoard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports